import { CuponeraPayment, CuponeraSeats } from '.';

import CuponeraSucessFailureScreen from './CuponeraSucessFailureScreen';

export default {
  path: '',
  name: 'cuponera',
  childRoutes: [
    {
      path: 'cuponera/seats',
      name: 'Default page',
      component: CuponeraSeats,
      isIndex: false,
    },
    {
      path: 'cuponera/payment',
      name: 'Default page',
      component: CuponeraPayment,
      isIndex: false,
    },
    {
      path: 'cuponera/payment/success/:pnr',
      name: 'Default page',
      component: CuponeraSucessFailureScreen,
      isIndex: false,
    },
    {
      path: 'cuponera/payment/success',
      name: 'Default page',
      component: CuponeraSucessFailureScreen,
      isIndex: false,
    },
    {
      path: 'cuponera/payment/failure',
      name: 'Default page',
      component: CuponeraSucessFailureScreen,
      isIndex: false,
    },
  ],
};



// WEBPACK FOOTER //
// ./src/features/cuponera/route.js